/*
 * @Description: feed相关的常量
 * @Author: fiveonelei
 * @Date: 2022-03-10 21:52:16
 * @FilePath: /vise/packages/app-share/src/constants/feed.ts
 */
export enum EFeedReserveType {
  exposureMaterialInfo = 51, // feed播放页曝光素材信息
  businessCard = 59, // 商业化字段，卡片需求，微视做透传
  business = 55, // 发表商业化字段json串
}
export enum EMaterialCategory {
  h5Activity = 'h5_activity',
  camera = 'camera',
  wsInteractTemplate = 'ws_interact_template',
  videofunny = 'videofunny',
  recommendTemplate = 'recommend_template',
  unknown = 'unknown',
}
